export enum SubEntityTypeIndex {
  Documents = 'documents',
  FrequentlyAskedQuestions = 'frequentlyaskedquestions',
  Software = 'software',
  Videos = 'videos',
  SerialNumberLocators = 'serialnumberlocators',
  BluetoothPairingGuides = 'bluetoothpairingguides',
  Applications = 'applications',
}

export enum SubEntityTypeName {
  Documents = 'Documents',
  FrequentlyAskedQuestions = 'FrequentlyAskedQuestions',
  Software = 'Software',
  Videos = 'Videos',
  SerialNumberLocators = 'SerialNumberLocators',
  BluetoothPairingGuides = 'BluetoothPairingGuides',
  Applications = 'Applications',
}

export const SubEntityType: Readonly<Record<SubEntityTypeName, SubEntityTypeIndex>> = {
  [SubEntityTypeName.Applications]: SubEntityTypeIndex.Applications,
  [SubEntityTypeName.BluetoothPairingGuides]: SubEntityTypeIndex.BluetoothPairingGuides,
  [SubEntityTypeName.Documents]: SubEntityTypeIndex.Documents,
  [SubEntityTypeName.FrequentlyAskedQuestions]: SubEntityTypeIndex.FrequentlyAskedQuestions,
  [SubEntityTypeName.SerialNumberLocators]: SubEntityTypeIndex.SerialNumberLocators,
  [SubEntityTypeName.Software]: SubEntityTypeIndex.Software,
  [SubEntityTypeName.Videos]: SubEntityTypeIndex.Videos,
};
